import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { useMemo } from 'react';
import { TABLE_CHECKBOX_CELL_WIDTH } from '../../Table/TableCheckboxCell/constants';
import { LEFT, RIGHT } from '../../../constants';
export var useDataTableStickyColumns = function useDataTableStickyColumns(columnsSafe, _ref) {
  var stickyLeftColumn = _ref.stickyLeftColumn,
      stickyRightColumn = _ref.stickyRightColumn,
      enableRowSelection = _ref.enableRowSelection,
      restProps = _objectWithoutProperties(_ref, ["stickyLeftColumn", "stickyRightColumn", "enableRowSelection"]);

  var stickyColumns = useMemo(function () {
    var columnMap = [];

    if (stickyLeftColumn) {
      columnMap.push({
        index: 0,
        alignment: LEFT,
        offset: 0
      });

      if (enableRowSelection) {
        columnMap.push({
          index: 1,
          alignment: LEFT,
          offset: TABLE_CHECKBOX_CELL_WIDTH
        });
      }
    }

    if (stickyRightColumn && columnsSafe.length > 1) {
      columnMap.push({
        index: columnsSafe.length - (enableRowSelection ? 0 : 1),
        alignment: RIGHT,
        offset: 0
      });
    }

    return columnMap;
  }, [stickyLeftColumn, stickyRightColumn, enableRowSelection, columnsSafe]);
  return {
    result: {
      stickyColumns: stickyColumns
    },
    restProps: restProps
  };
};